(function() {
    const DEBUG = true;
    function log(...args) {
        if (!DEBUG) return;
        console.log('[cart-extra]', ...args);
    }

    document.addEventListener("DOMContentLoaded", () => {
        const form = document.querySelector('form.cart-recap');
        if (!form) return;

        const extraFields = document.getElementById('cart-extra-fields');
        if (!extraFields) {
            log("Extra fields are disabled");
            return;
        }

        const complianceCheckbox = document.getElementById('cart_compliance');
        const buyerTypeRadios = form.querySelectorAll('input[name="buyer_type"]');
        const taxWrapper = document.getElementById('tax-number-wrapper');
        const taxInput = document.getElementById('company_tax_number');
        const checkoutBtn = form.querySelector('.cart-recap__checkout');
        const errorEl = document.getElementById('cart-extra-error');

        const attrBuyerType = document.getElementById('attr_buyer_type');
        const attrTax = document.getElementById('attr_company_tax_number');
        const attrCompliance = document.getElementById('attr_compliance_accepted');

        const errorComplianceText = extraFields.dataset.errorCompliance || 'Please confirm that you accept the terms and conditions.';
        const errorTaxText = extraFields.dataset.errorTax || 'Please enter the company tax number.';
        const errorBuyerTypeText = extraFields.dataset.errorBuyerType || 'Please select the buyer type.';

        if (
            !complianceCheckbox ||
            !buyerTypeRadios.length ||
            !taxWrapper ||
            !taxInput ||
            !checkoutBtn ||
            !attrBuyerType ||
            !attrTax ||
            !attrCompliance
        ) {
            log('Missing one or more required elements, aborting.');
            return;
        }

        function getSelectedBuyerType() {
            let type = '';
            buyerTypeRadios.forEach(r => {
                if (r.checked) {
                    type = r.value;
                }
            });
            log("[getSelectedBuyerType] Type:", type || '(none)');
            return type;
        }

        function updateTaxVisibility() {
            const type = getSelectedBuyerType();
            if (type === 'company') {
                taxWrapper.style.display = '';
            } else {
                taxWrapper.style.display = 'none';
            }
        }

        function syncHiddenFields() {
            const type = getSelectedBuyerType();
            attrBuyerType.value = type || '';
            attrTax.value = (taxInput.value || '').trim();
            attrCompliance.value = complianceCheckbox.checked ? 'yes' : '';
        }

        function setError(message) {
            if (message) {
                errorEl.textContent = message;
                errorEl.style.display = 'block';
            } else {
                errorEl.textContent = '';
                errorEl.style.display = 'none';
            }
        }

        function validate(showMessage) {
            let valid = true;
            const messages = [];
            const type = getSelectedBuyerType();

            if (!type) {
                valid = false;
                messages.push(errorBuyerTypeText);
            }

            if (!complianceCheckbox.checked) {
                valid = false;
                messages.push(errorComplianceText);
            }

            if (type === 'company') {
                if (!taxInput.value.trim()) {
                    valid = false;
                    messages.push(errorTaxText);
                }
            }

            if (showMessage) {
                setError(valid ? '' : messages.join(' '));
            } else if (valid) {
                setError('');
            }

            checkoutBtn.disabled = !valid;

            return valid;
        }

        // Init on load
        updateTaxVisibility();
        syncHiddenFields();
        validate(false);

        complianceCheckbox.addEventListener('change', () => {
            syncHiddenFields();
            validate(false);
        });

        buyerTypeRadios.forEach((radio) => {
            radio.addEventListener('change', () => {
                updateTaxVisibility();
                syncHiddenFields();
                validate(false);
            });
        });

        taxInput.addEventListener('input', () => {
            syncHiddenFields();
            validate(false);
        });

        form.addEventListener('submit', (e) => {
            if (!validate(true)) {
                e.preventDefault();
                e.stopPropagation();

                const type = getSelectedBuyerType();

                if (!type) {
                    buyerTypeRadios[0].focus();
                } else if (!complianceCheckbox.checked) {
                    complianceCheckbox.focus();
                } else if (type === 'company' && !taxInput.value.trim()) {
                    taxInput.focus();
                }
            }
        });
    });
})();
